import * as React from "react";
import * as ReactDOM from "react-dom";
import { UitkSecondaryButton } from "@egencia/uitk-react";
import { PanelHeader } from "../react/panel-header.jsx";
import { UitkLayoutFlex } from "@egencia/uitk-react";
import {EgenciaProvider} from "@egencia/uitk-react";
import {UitkText} from "@egencia/uitk-react";
import {UitkSpacing} from "@egencia/uitk-react";
const { chatData, anonymousUser } = EG.bootstrapped;

EG.HelpCenter.Presenters.PanelContactOptions = function () {  
    const panelViewName = "ContactOptions";  
    const callUrl = EG.bootstrapped.callUrl;
    const emailUrl = EG.bootstrapped.emailUrl;
    const title = uitk.i18n.msg("panel_contact_us_button");
    const selectContactMethod = uitk.i18n.msg("select_contact_method");
    const contactCall = uitk.i18n.msg("contact_call");
    const customerCareEmail = EG.analytics.configs["home.display_customer_care_email"].value.display;
    const contactOptionsContainer = ReactDOM.createRoot(document.querySelector("#contact-options-container"));
    
    function openCallUrl(){
        omnitureLog.logClickEvent('HelpCenter.Panel.Contact.Call.Clicked');
        location.href = callUrl;
    }
    
    function openEmailUrl(){
        omnitureLog.logClickEvent('HelpCenter.Panel.Contact.Email.Clicked');
        location.href = emailUrl;
    }

    contactOptionsContainer.render(
        <EgenciaProvider>
            <PanelHeader title={title} hasSearch={false} hasBackBtn={EG.bootstrapped.hasBackBtn} panelViewName={panelViewName}></PanelHeader>
            <UitkSpacing padding="four">
                <div>
                    <UitkSpacing margin={{block: "two"}}>
                        <UitkText tag="h2" size={5}>{selectContactMethod}</UitkText>
                    </UitkSpacing>
                    <UitkLayoutFlex direction="column" space="six">
                        <>
                            {getChatButton(anonymousUser, chatData)}
                            <UitkSecondaryButton className="btn-phone" onClick={openCallUrl} icon="phone">{contactCall}</UitkSecondaryButton>
                            {getEmailButton(customerCareEmail, anonymousUser, openEmailUrl)}
                        </>
                    </UitkLayoutFlex>
                </div>
            </UitkSpacing>
        </EgenciaProvider>
    );
    
    uitk.analytics.set('pageName', EG.pageName);
    uitk.analytics.send();
};

function getChatButton(anonymousUser, chatData){
    if(anonymousUser) return <></>;
    if(!chatData || !chatData.showChatButton) return <></>;
    
    const newContactChat = uitk.i18n.msg("new_contact_chat");
    
    if(chatData.chatBotOrCpEnabled){
        return (
            <UitkSecondaryButton className="btn-chat" icon="chat" onClick={window.openChat}>{newContactChat}</UitkSecondaryButton>
        );
    }
    
    return "";
}

function getEmailButton(customerCareEmail, anonymousUser, openEmailUrl){
    if(anonymousUser) return <></>;
    const contactEmail = uitk.i18n.msg("contact_email");
    
    return customerCareEmail
        ? <UitkSecondaryButton className="btn-email" onClick={openEmailUrl} icon="email">{contactEmail}</UitkSecondaryButton>
        : <></>
}
